import { useState } from "react";
import { toast } from "sonner";
import { FlaskConical, Loader2 } from "lucide-react";
import { portalApi } from "@/lib/portalApi";
import { usePortalAuth } from "@/context/PortalAuthContext";

export const ResearchConsentCard = () => {
  const { user, setUser } = usePortalAuth();
  const [saving, setSaving] = useState(false);

  if (!user) return null;
  const optedOut = !!user.research_opt_out;

  const toggle = async () => {
    setSaving(true);
    try {
      const res = await portalApi.researchConsent(!optedOut);
      setUser(res.user);
      toast.success(res.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="mt-5 border border-slate-800 bg-[#0B1220]/70 p-6 md:p-8"
      data-testid="research-consent-card"
    >
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-5">
        <div className="flex items-start gap-4">
          <FlaskConical className="text-[#D4AF37] shrink-0 mt-0.5" size={20} />
          <div>
            <h3 className="font-serif text-lg text-white mb-2">
              {optedOut ? "Your data stays out of the research" : "You are helping the research"}
            </h3>
            <p className="text-slate-400 text-sm max-w-xl leading-relaxed">
              {optedOut
                ? "Nothing from your account is used in the clinic's case base. Turn this back on and your coded scores rejoin the comparison set at your next report."
                : "Your scores are added to the clinic's case base as coded numbers only — never your name, your employer or anything you have written. It is what lets the next person be compared against real cases."}
            </p>
          </div>
        </div>
        <button
          onClick={toggle}
          disabled={saving}
          data-testid="research-consent-toggle"
          className={`shrink-0 px-6 py-3 text-xs uppercase tracking-[0.2em] transition-colors inline-flex items-center justify-center gap-2 ${
            optedOut
              ? "bg-[#D4AF37] text-slate-950 hover:bg-[#B5952F]"
              : "border border-slate-700 text-slate-300 hover:border-[#D4AF37] hover:text-[#D4AF37]"
          } disabled:opacity-50`}
        >
          {saving && <Loader2 className="animate-spin" size={14} />}
          {optedOut ? "Include my data again" : "Withdraw my data"}
        </button>
      </div>
    </div>
  );
};
